import { ActionResult } from '../enums';
import type { ActionHandler } from '../types';
import { isRecord } from '~/services/layout/layout.ts';

/**
 * Reads a toggle-favorite callback from the action context when present.
 */
function getToggleFavorite(context: unknown): (() => void) | undefined {
  if (!isRecord(context)) {
    return undefined;
  }

  const toggleFavorite = context.toggleFavorite;

  return typeof toggleFavorite === 'function'
    ? (toggleFavorite as () => void)
    : undefined;
}

/**
 * Toggles the favorite state of the entry through the favorites action
 * provided by the surface rendering the action menu.
 */
export const toggleFavoriteAction: ActionHandler = async (action) => {
  const toggleFavorite = getToggleFavorite(action.context);

  if (!toggleFavorite) {
    return ActionResult.Error;
  }

  toggleFavorite();

  return ActionResult.Success;
};
